import memoizeOne from "memoize-one";
import { TableColumn } from "react-data-table-component";
import { TicketFieldSetting } from "src/sdk/models/Organisation";
import DropdownFieldSetting from "./DropdownFieldSetting";

export const FieldSettingColumns = memoizeOne(
  (
    onEditField: (values: TicketFieldSetting) => void,
  ): TableColumn<TicketFieldSetting>[] => {
    return [
      {
        id: "fieldId",
        selector: (row) => row.fieldId,
        sortable: true,
        name: "Field ID",
        width: "106px",
      },
      {
        id: "name",
        selector: (row) => row.name,
        sortable: true,
        name: "Name",
      },
      {
        id: "label",
        selector: (row) => row.label,
        sortable: true,
        name: "Label",
      },
      {
        id: "orderNo",
        selector: (row) => row.orderNo,
        sortable: true,
        name: "Order No",
      },
      {
        id: "type",
        selector: (row) => row.type,
        sortable: true,
        name: "Type",
      },
      {
        id: "sortable",
        sortable: true,
        name: "Sortable",
        cell: (row) => (
          <div className="m-auto h4">
            {row.sortable ? (
              <span className="bi bi-check-lg green-color" />
            ) : (
              <span className="bi bi-x red-color" />
            )}
          </div>
        ),
      },
      {
        id: "showOnList",
        sortable: true,
        name: "Show on list",
        cell: (row) => (
          <div className="m-auto h4">
            {row.showOnList ? (
              <span className="bi bi-check-lg green-color" />
            ) : (
              <span className="bi bi-x red-color" />
            )}
          </div>
        ),
      },
      {
        id: "showOnForm",
        sortable: true,
        name: "Show on form",
        cell: (row) => (
          <div className="m-auto h4">
            {row.showOnForm ? (
              <span className="bi bi-check-lg green-color" />
            ) : (
              <span className="bi bi-x red-color" />
            )}
          </div>
        ),
      },
      {
        cell: (row) => (
          <div className="m-auto">
            <DropdownFieldSetting
              values={row}
              onEditField={onEditField}
            />
          </div>
        ),
        width: "150px",
      },
    ];
  },
);
